import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GlameraSharedService } from './glamera-shared.service';
import { Feature, NonSubscribedBranchesNoPaginate, SubscriptionDetails } from '../../plans/plans';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class PlansService {
  private companyId = 0;
  public subscriptionButtons: { name: string, value: 'cycle30' | 'cycle360' }[] = [
    { name: 'translate_monthly', value: 'cycle30' },
    { name: 'translate_yearly', value: 'cycle360' }
  ];


  get apiUrl(): string {
    return `${environment.apiUrl}/subs/web/system/packages/features`;
  }


  get nonSubscribedBranchesApiUrl(): string {
    return `${environment.apiUrl}/subs/web/company/${this.companyId}/subscriptions/nonSubscripedBranches`;
  }

  get subscriptionPlansApiUrl(): string {
    return `${environment.apiUrl}/subs/web/company/${this.companyId}/subscriptions`;
  }

  get subscriptionUrl(): string {
    return `${environment.apiUrl}/subs/web/company/${this.companyId}/subscriptions`;
  }



  get token(): string {
    return this.sharedService.token ?? "";
  }

  constructor(private http: HttpClient,
    private sharedService: GlameraSharedService
  ) {
    this.companyId = sharedService.company.id;
  }


  getPlans(): Observable<any> {
    const token = this.token;
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);

    return this.http.get<any>(this.apiUrl, { headers });
  }

  getNonSubscribedBranches(PagingEnabled = true): Observable<NonSubscribedBranchesNoPaginate> {
    const token = this.token;
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);

    return this.http.get<NonSubscribedBranchesNoPaginate>(`${environment.apiUrl}/subs/web/company/${this.companyId}/subscriptions/nonSubscripedBranches?PagingEnabled=${PagingEnabled}`, { headers });
  }

  getSubscriptionPlans(): Observable<any> {
    const token = this.token;
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);

    return this.http.get<any>(this.subscriptionPlansApiUrl, { headers });
  }

  getSubscriptionsDetails(id: number): Observable<SubscriptionDetails> {
    const token = this.token;
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);

    return this.http.get<SubscriptionDetails>(`${environment.apiUrl}/subs/web/company/${this.companyId}/subscriptions/lite/${id}`, { headers });
  }

  subscribeToPlan(subscriptionData: any): Observable<any> {
    const token = this.token;
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
      'AppId': '7',
      'lang': 'ar'
    });

    return this.http.post<any>(this.subscriptionUrl, subscriptionData, {
      headers,
    });
  }

  upgradeSubscription(subscriptionData: any): Observable<any> {
    const token = this.token;
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
      'AppId': '7',
      'lang': 'ar'
    });

    return this.http.post<any>(this.subscriptionUrl + "/upgrade", subscriptionData, {
      headers,
    });
  }


  getSubscriptionDetails(): Observable<any> {

    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.token}`);

    return this.http.get<any>(this.subscriptionPlansApiUrl, { headers });
  }

  checkSubscriptionChange(subscriptionData: any): Observable<any> {
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.token}`);
    return this.http.get<any>(this.subscriptionUrl + "/change/check", { headers, params: subscriptionData });
  }

  public getSortedFeatures(features: Feature[]): Feature[] {
    return features.sort((a, b) => (b.isExist ? 1 : 0) - (a.isExist ? 1 : 0));;
  }

  public getPlanType(plan: number | string): string {
    const planToType: Record<string, string> = {
      30: 'translate_monthly',
      360: 'translate_yearly',
      cycle30: 'translate_monthly',
      cycle360: 'translate_yearly',
    };

    return planToType[plan] || 'Unknown';
  }

}
